module.exports = __webpack_public_path__ + "assets/local_phone.578bef1fc01c5ffaa3686fb58970275e.svg";